import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
// 登录验证
export default new Vuex.Store({
    state: {
        user: false,
        getprovince:[], // 地址联动
        isShowNav:true,
        gotRedPack:[],
        currentAddress:{},
        erweimaUrl:'',
        logo:"", //全局的logo
        list:[], //购物车的数据
        accountTotal:0, // 购物车的金额
        totalNumber:0, // 购物车数量
        copyRight:{}, // 版权相关信息
        userImg:{},
        kjtEnable:{ 
           enable:true,  // 总开关
           merchant:true, // 店铺是否有快捷通
           H5:true, // 支付宝/微信二维码
        }, // 快捷通开关集合
        // isBaselineVersion:false,
    },
    mutations: {
        // 登录
        login(state, user) {
            state.user = user;
            localStorage.setItem("userInfo", user);
        },
        // 退出
        logout(state, user) {
            state.user = "";
            localStorage.setItem("userInfo", "");
        },
        // 地址
        getAddress(state,param){
            state.getprovince = param
        },
        // 是否展示导航栏
        getisShowNav(state,param){
            state.isShowNav = param
        },
        //  已领取的 为了做对比,防止多次领取
        gotRedPackred(state,param){
            console.log(state,param,'防止多次领取')
            state.gotRedPack = param
        },
        //  记录当前的位置
        gotCurrentAddress(state,param){
            state.currentAddress = param
            console.log(state.currentAddress,'记录当前的位置')
        },
        // 获取微信二维码
        getWxerweima(state,param){
            state.erweimaUrl = param
            console.log(state.erweimaUrl,'二维码')
        },
        //获取全局的logo
        getLogo(state,params){
            state.logo = params.pcLogo
            console.log(state);
        },
        // 获取版权相关信息
        getcopyRight(state,params){
            state.copyRight = params
            console.log(state);
        },
         // 获取快捷通 开关集合
         getkjtEnable(state,params){
            state.kjtEnable = params
            console.log(state);
        },
        // 查询默认图片
        getUserImg(state,params){
            state.userImg = params
        },
        // 获取购物车内容
        getCartList(state,params){
            if(params.length==0){
                state.accountTotal=0 
            }
                state.list = params
                let newList= []  
                params.forEach((x)=>{ 
                if(x.bxunyouMerchant){
                    x.bxunyouMerchant.goods.forEach((y)=>{
                        newList.push(y)
                    })
                }else{
                    x.goods.forEach((y)=>{
                        newList.push(y)
                    })
                }  
            })
            state.list = newList;
            let sum = 0
            state.accountTotal = 0
                 sum = state.list.reduce((sum, item) => {    
                                        
                        return sum + item.realprice * item.number; // 隐式转换             
                    }, 0);
                let number = 0
                state.list.forEach((item)=>{
                    number += item.number
                })
                state.totalNumber = number
                state.accountTotal += sum;
        }
    }
})


// WEBPACK FOOTER //
// ./src/vuex/store.js